/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsUnmarkAsStarredRequest,
  TChatsUnmarkAsStarredModel,
  IMappers,
  TChatsUnmarkAsStarredResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IMarkAsStarredV2Response } from '../../../entities/mark_as_starred/MarkAsStarredV2Response';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsUnmarkAsStarredModel(parameters: TChatsUnmarkAsStarredRequest): TChatsUnmarkAsStarredModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v2/chats/unmark-as-starred/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsUnmarkAsStarredOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsUnmarkAsStarredRequest;
}

export async function fetchChatsUnmarkAsStarred<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsUnmarkAsStarredOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsUnmarkAsStarredResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsUnmarkAsStarredModel(parameters),
    config,
  )) as FetchResponse<TChatsUnmarkAsStarredResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMarkAsStarredV2Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsUnmarkAsStarredResponse>;
}
